import React, { useState } from 'react';

import { removeLeadingSlash } from '~/utils/removeLeadingSlash';

import type { CategoryLink } from '../../types/CategoryLink.interface';

import FooterNavColumnTitle from './components/FooterNavColumnTitle';
import styles from './FooterNavColumn.module.css';

export const FooterNavColumn = ({ links, name }: CategoryLink): JSX.Element => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <li data-testid="footer-column" className={styles.footerNavColumnWrapper}>
			<FooterNavColumnTitle isOpen={isOpen} toggle={toggle} title={name} />
			<ul
        className={`${styles.footerNavLinksList} ${isOpen ? styles.open : ''}`}>

				{links.map(({ name, url }) =>
        <li className={styles.standardLinksListItem} key={name}>
						<a
            className={styles.standardLink}
            href={removeLeadingSlash(url)}
            title={name}>

							{name}
						</a>
					</li>
        )}
			</ul>
		</li>);

};